import LoadingContainer from '../Containers/LoadingContainer/LoadingContainer'

type EntityToLoad = {
    id: string
    load: () => Promise<void>
    loaded: boolean
}

class LoadingController {
    private entitiesToLoad: Record<string, EntityToLoad> = {}

    addToQueue = (entity: { id: string; load: () => Promise<void> }) => {
        this.entitiesToLoad = {
            ...this.entitiesToLoad,
            [entity.id]: {
                id: entity.id,
                load: entity.load,
                loaded: false,
            },
        }
    }

    processQueue = async () => {
        LoadingContainer.resetProgress()

        return Promise.all(
            Object.keys(this.entitiesToLoad).map(async (id) => {
                await this.entitiesToLoad[id].load()
                this.entitiesToLoad = {
                    ...this.entitiesToLoad,
                    [id]: {
                        ...this.entitiesToLoad[id],
                        loaded: true,
                    },
                }
                this.updateView()
            })
        )
    }

    reset = () => {
        this.entitiesToLoad = {}
        LoadingContainer.resetProgress()
    }

    private calculateProgress = () => {
        const allCount = Object.keys(this.entitiesToLoad).length
        const loadedCount = Object.keys(this.entitiesToLoad).filter((id) => this.entitiesToLoad[id].loaded === true)
            .length

        return Math.floor((loadedCount / allCount) * 100)
    }

    private updateView = () => {
        LoadingContainer.setProgress(this.calculateProgress())
    }
}

export default new LoadingController()
